module.exports = __webpack_public_path__ + "static/store-view-new2-acb00c993f46681a9945de2e594fd743.jpg";